module.exports = __webpack_public_path__ + "static/media/load-spinner.0257fe46.svg";